import { makeStyles, TextField, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'

const useStyles = makeStyles({
    text: {
        fontSize: 14,
        color: 'rgba(9, 12, 16, 0.6)',
        marginBottom: 16,
        wordBreak: 'break-word'
    }
})

type Props = {
    isEditMode: boolean
    note?: string
    onUpdate: (_value: string) => void
}

export const StepDescription = ({ isEditMode, note = '', onUpdate }: Props) => {
    const classes = useStyles()

    const [noteField, setNoteField] = useState(note)

    useEffect(() => {
        setNoteField(note)
    }, [note])

    if (isEditMode) {
        return (
            <TextField
                style={{ marginBottom: 16 }}
                label="Description"
                value={noteField}
                variant="filled"
                fullWidth
                multiline
                onBlur={() => {
                    // we need to make update only if field was changed
                    if (note !== noteField) onUpdate(noteField)
                }}
                onClick={e => e.stopPropagation()}
                onChange={({ target }) => setNoteField(target.value)}
                inputProps={{ maxLength: 1500 }}
            />
        )
    }

    if (!note) return null

    return <Typography className={classes.text}>{note}</Typography>
}
